<template>
	<v-dialog v-model="imagemDialog" max-width="1024" max-heigth="1024" scrollable>
		<div>
			<v-img :src="imgSrc" max-height="1024" max-width="1024" />
		</div>
	</v-dialog>
</template>
<script>
export default {
	props: {
		imgSrc: String,
		dialog: Boolean,
	},
	data: function () {
		return {
			loading: false,
		}
	},
	computed: {
		imagemDialog: {
			get() {
				return this.dialog
			},
			set() {
				this.dialogClose()
			},
		},
	},
	methods: {
		dialogClose() {
			this.$emit('dialogClose')
		},
	},
	watch: {},
}
</script>
